import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from "recharts";

import { i18n } from "../../translate/i18n";
import { CHART_COLORS } from "./format";

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    padding: "16px 18px",
  },
  title: { fontSize: 13, fontWeight: 700, letterSpacing: 0.4, textTransform: "uppercase", marginBottom: 12 },
  empty: { fontSize: 14, color: theme.palette.text.secondary, padding: "24px 0", textAlign: "center" },
  note: { fontSize: 12, color: theme.palette.text.secondary, marginTop: 8 },
}));

/** Pestaña «Etiquetas» (doc 0447 §5): las más aplicadas en el periodo, con su color. */
const TagsTab = ({ data }) => {
  const classes = useStyles();
  const theme = useTheme();
  const tags = (data.tags || []).map((t) => ({
    ...t,
    name: t.kanban ? `${t.label} · Kanban` : t.label,
  }));

  return (
    <div className={classes.card}>
      <div className={classes.title}>{i18n.t("reports.tags.title")}</div>
      {tags.length === 0 ? (
        <div className={classes.empty}>{i18n.t("reports.empty")}</div>
      ) : (
        <ResponsiveContainer width="100%" height={Math.max(160, tags.length * 36)}>
          <BarChart data={tags} layout="vertical" margin={{ top: 0, right: 24, left: 8, bottom: 0 }}>
            <XAxis type="number" allowDecimals={false} tick={{ fontSize: 12, fill: theme.palette.text.secondary }} />
            <YAxis type="category" dataKey="name" width={220} tick={{ fontSize: 12, fill: theme.palette.text.secondary }} />
            <Tooltip />
            <Bar dataKey="applied" name={i18n.t("reports.tags.applied")} radius={[0, 4, 4, 0]}>
              {tags.map((t, i) => <Cell key={t.id} fill={t.color || CHART_COLORS[i % CHART_COLORS.length]} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
      <div className={classes.note}>{i18n.t("reports.tags.note")}</div>
    </div>
  );
};

export default TagsTab;
